import ExitWarningModal from './exit-warning-modal';

export default ExitWarningModal;
